import React from "react";

const Step4 = ({ formData }) => {
  const {
    configProducto = "",
    configModulos = [],
    organizationName = "Tu Organización",
    organizacionEstado = "No especificada",
    adminName = "Nombre del Administrador",
    adminRole = "Administrador General",
  } = formData;

  // Mapeo de módulos para mostrar
  const modulosMap = {
    sic: { label: "SIC", color: "#4a6502" },
    acopio: { label: "Acopio", color: "#6ba32f" },
    eudr: { label: "EUDR", color: "#8cb63e" },
    calidad: { label: "Calidad", color: "#a8c64d" },
  };

  const modulosActivos = configModulos
    .map((id) => modulosMap[id])
    .filter(Boolean);

  return (
    <div style={{ paddingBottom: "40px" }}>
      {/* HEADER */}
      <div className="mb-5">
        <h1 className="fw-bold mb-3" style={{ fontSize: "2.5rem", color: "#1a1a1a" }}>
          ¡Todo listo!
          <br />
          Empecemos a trabajar.
        </h1>
        <p className="text-muted mb-0" style={{ fontSize: "0.95rem", lineHeight: "1.6", color: "#666" }}>
          Tu espacio de trabajo ha sido configurado correctamente. Revisa los detalles
          <br />
          de tu organización y sigue los pasos para comenzar.
        </p>
      </div>

      {/* RESUMEN CARD - DOS COLUMNAS */}
      <div className="row mb-5">
        <div className="col-12">
          <div
            className="card border-0"
            style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              boxShadow: "0 4px 24px rgba(15, 23, 42, 0.08)",
              overflow: "hidden",
              padding: "24px",
            }}
          >
            <div className="row g-0 align-items-start p-4 p-lg-5">

              {/* COLUMNA IZQUIERDA */}
              <div className="col-12 col-md-6" style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
                {/* Icono + Label + Nombre */}
                <div>
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "16px",
                      backgroundColor: "#f8fafc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#526b08",
                      marginBottom: "0.75rem",
                    }}
                  >
                    <i className="fa-solid fa-building-user" style={{ fontSize: "1.15rem" }} />
                  </div>
                  <span
                    className="text-uppercase d-block"
                    style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.25rem" }}
                  >
                    Resumen del espacio
                  </span>
                  <h3 className="fw-bold mb-0" style={{ fontSize: "1.25rem", color: "#111827" }}>
                    {organizationName}
                  </h3>
                </div>

                {/* Producto + Región */}
                <div className="row g-3 pt-1">
                  <div className="col-6">
                    <span
                      className="text-uppercase d-block"
                      style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.35rem" }}
                    >
                      Producto principal
                    </span>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-seedling" style={{ color: "#16a34a", fontSize: "0.75rem" }}></i>
                      <span className="fw-semibold" style={{ fontSize: "0.875rem", color: "#374151" }}>
                        {configProducto === "cafe"
                          ? "Café"
                          : configProducto === "cacao"
                          ? "Cacao"
                          : configProducto || "No seleccionado"}
                      </span>
                    </div>
                  </div>
                  <div className="col-6">
                    <span
                      className="text-uppercase d-block"
                      style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.35rem" }}
                    >
                      Región
                    </span>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa-solid fa-location-dot" style={{ color: "#ef4444", fontSize: "0.75rem" }}></i>
                      <span className="fw-semibold" style={{ fontSize: "0.875rem", color: "#374151" }}>
                        {organizacionEstado}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Módulos activos */}
                <div>
                  <span
                    className="text-uppercase d-block"
                    style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.75rem" }}
                  >
                    Módulos activos
                  </span>
                  <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
                    {modulosActivos.length > 0 ? (
                      modulosActivos.map((mod, idx) => (
                        <span
                          key={idx}
                          style={{
                            display: "inline-block",
                            backgroundColor: "#f4f6ee",
                            color: "#526b08",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            borderRadius: "999px",
                            padding: "4px 12px",
                          }}
                        >
                          {mod.label}
                        </span>
                      ))
                    ) : (
                      <span style={{ color: "#9ca3af", fontSize: "0.875rem" }}>
                        No hay módulos seleccionados
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* COLUMNA DERECHA */}
              <div
                className="col-12 col-md-6 mt-5 mt-md-0 ps-md-5"
                style={{ borderLeft: "1px solid #e5e7eb", display: "flex", flexDirection: "column", gap: "2rem" }}
              >
                <div>
                  <span
                    className="text-uppercase d-block"
                    style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.75rem" }}
                  >
                    Tu acceso
                  </span>
                  <div
                    className="d-flex align-items-center gap-3"
                    style={{
                      backgroundColor: "rgba(239, 246, 255, 0.5)",
                      border: "1px solid #dbeafe",
                      borderRadius: "20px",
                      padding: "1rem 1.1rem",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#dbeafe",
                        color: "#2563eb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <i className="fa-solid fa-shield-halved" style={{ fontSize: "1rem" }} />
                    </div>
                    <div>
                      <p className="fw-bold mb-1" style={{ fontSize: "0.875rem", color: "#1f2937" }}>
                        {adminName}
                      </p>
                      <p className="mb-0" style={{ fontSize: "0.7rem", color: "#2563eb", fontWeight: "500" }}>
                        {adminRole}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* ¿QUÉ SIGUE AHORA? */}
      <div className="mb-5">
        <h5
          className="fw-bold mb-4"
          style={{ color: "#8c98a4", fontSize: "0.9rem", letterSpacing: "0.5px" }}
        >
          ¿QUÉ SIGUE AHORA?
        </h5>

        <div className="row g-4">
          {/* PASO 1 */}
          <div className="col-12 col-md-6">
            <div
              className="card border-0 h-100"
              style={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                borderRadius: "12px",
                padding: "24px",
              }}
            >
              <div className="d-flex gap-3">
                {/* NÚMERO PASO */}
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#4a6502",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    flexShrink: 0,
                    marginRight: "1rem",
                  }}
                >
                  1
                </div>
                {/* CONTENIDO */}
                <div>
                  <h6 className="fw-bold mb-2" style={{ color: "#1a1a1a", fontSize: "1rem" }}>
                    Importa Productores, Parcelas y Mapas
                  </h6>
                  <p
                    className="text-muted mb-3"
                    style={{ fontSize: "0.85rem", lineHeight: "1.5" }}
                  >
                    Carga tu padrón de socios, listado completo de parcelas o mapas mediante
                    archivos Excel o KML.
                  </p>
                  <p className="text-muted mb-3" style={{ fontSize: "0.75rem" }}>
                    <strong>Nota:</strong> Esta información puede tardarse unos días en verse
                    reflejada en tu cuenta.
                  </p>
                  <a
                    href="#"
                    className="fw-bold"
                    style={{
                      color: "#4a6502",
                      fontSize: "0.85rem",
                      textDecoration: "none",
                    }}
                  >
                    <i className="fa fa-download me-1"></i> Subir archivos
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* PASO 2 */}
          <div className="col-12 col-md-6">
            <div
              className="card border-0 h-100"
              style={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                borderRadius: "12px",
                padding: "24px",
              }}
            >
              <div className="d-flex gap-3">
                {/* NÚMERO PASO */}
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#f39c12",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    flexShrink: 0,
                    marginRight: "1rem",
                  }}
                >
                  2
                </div>
                {/* CONTENIDO */}
                <div>
                  <h6 className="fw-bold mb-2" style={{ color: "#1a1a1a", fontSize: "1rem" }}>
                    Agenda una llamada con nosotros
                  </h6>
                  <p
                    className="text-muted mb-3"
                    style={{ fontSize: "0.85rem", lineHeight: "1.5" }}
                  >
                    Nuestro equipo de soporte te contactará pronto para una sesión
                    personalizada, pero puedes adelantarte y elegir el horario que prefieras.
                  </p>
                  <a
                    href="#"
                    className="fw-bold"
                    style={{
                      color: "#dc3545",
                      fontSize: "0.85rem",
                      textDecoration: "none",
                    }}
                  >
                    Ver horarios disponibles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Step4;
